/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_M2_YearInputs */

const cs_price_unit_suffix_m2_year = /** @type {(inputs: Price_Unit_Suffix_M2_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/rok`)
};

const en_price_unit_suffix_m2_year = /** @type {(inputs: Price_Unit_Suffix_M2_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/m²/yr`)
};

/**
* | output |
* | --- |
* | "/m²/yr" |
*
* @param {Price_Unit_Suffix_M2_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_m2_year = /** @type {((inputs?: Price_Unit_Suffix_M2_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_M2_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_m2_year(inputs)
	return cs_price_unit_suffix_m2_year(inputs)
});